import React from "react";
import { Modal, Icon, Button } from "antd";
import ModalContentHolder from "./Styles/ModalContentStyle";
import { useTranslation } from "react-i18next";

import Colors from '../themes/Colors';
const ModalChangeDates = ({ visible = false, onCancel }) => {
  const { t } = useTranslation();

  return (
    <>
      {visible &&
        <Modal
          title={<span style={{ fontWeight: "bold" }}>{t("Attention: Review the impression rules.")}</span>}
          visible={visible}
          onCancel={onCancel}
          footer={[
            <Button key="submit" type="primary" onClick={onCancel}>
              {t("Confirm")}
            </Button>
          ]}
          width={600}
        >
          <ModalContentHolder style={{ padding: "20px", marginBottom: "-16px" }}>
            <div style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginBottom: "16px"
            }}>
              <Icon
                type="warning"
                theme="outlined"
                style={{
                  color: "#ffc107",
                  fontSize: "48px"
                }}
              />
            </div>
            
            <p>{t("You have modified the campaign start and/or end date.")}</p>
            <p>{t("The configured impression rules were automatically adjusted to match the new date range.")}</p>

            <div style={{ 
              backgroundColor: Colors.tintWarning, 
              border: '1px solid #ffe58f',
              gap: '8px', 
              padding: '15px', 
              borderRadius: '4px',
              marginTop: '20px',
              display: 'flex'
            }}>
              <p style={{ fontWeight: "bold", color: "#856404", marginBottom: '5px' }}>
                ⚠ {t("Important:")}
              </p>
              <p style={{ fontSize: '13px', margin: 0 }}>
                {t("We recommend manually reviewing the impression rules, especially the days of the week and time slots, to ensure they remain aligned with the campaign objective.")}
              </p>
            </div>

            <p style={{ marginTop: '15px', fontSize: '12px', fontStyle: 'italic', color: Colors.textMuted }}>
              {t("Automatic adjustments do not take strategic planning changes into account.")}
            </p>
          </ModalContentHolder>
        </Modal>
      }
    </>
  );
};

export default ModalChangeDates;